import React from "react";
import styled from "styled-components";

const TestimonialsSection = styled.section`
  padding: 80px 0;
  background: var(--background-dark);
  color: white;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const SectionTitle = styled.h2`
  text-align: center;
  margin-bottom: 60px;
  font-family: "Inter", sans-serif;
  font-size: 3rem;
  color: white;
`;

const TestimonialCard = styled.div`
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.05);
  padding: 60px 40px;
  border-radius: 20px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

const StarRating = styled.div`
  display: flex;
  justify-content: center;
  gap: 5px;
  margin-bottom: 30px;

  span {
    color: var(--secondary-color);
    font-size: 1.8rem;
  }
`;

const TestimonialTitle = styled.h3`
  margin-bottom: 25px;
  font-family: "Inter", sans-serif;
  font-size: 1.8rem;
  color: white;
`;

const TestimonialText = styled.p`
  font-size: 1.2rem;
  line-height: 1.8;
  color: #d1d5db;
  font-family: "Inter", sans-serif;
  font-style: italic;
  margin-bottom: 40px;
`;

const AuthorInfo = styled.div`
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;

const AuthorImage = styled.img`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid var(--secondary-color);
`;

const AuthorDetails = styled.div`
  text-align: left;
`;

const AuthorName = styled.h4`
  margin: 0;
  color: var(--secondary-color);
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 1.1rem;
`;

const AuthorLocation = styled.p`
  margin: 5px 0 0 0;
  color: #9ca3af;
  font-family: "Inter", sans-serif;
`;

const Testimonials = () => {
  return (
    <TestimonialsSection>
      <Container>
        <SectionTitle>Customer Testimonials</SectionTitle>

        <TestimonialCard>
          <StarRating>
            {[...Array(5)].map((_, i) => (
              <span key={i}>★</span>
            ))}
          </StarRating>

          <TestimonialTitle>
            Exactly what I needed for extra storage.
          </TestimonialTitle>

          <TestimonialText>
            "I purchased a 20ft used container from Baypoint Storage and the
            process was seamless. The container was delivered on time and in
            excellent condition. Highly recommend!"
          </TestimonialText>

          <AuthorInfo>
            <AuthorImage src="/assets/2025/08/Testi1.jpg" alt="Sandra L." />
            <AuthorDetails>
              <AuthorName>Sandra L.</AuthorName>
              <AuthorLocation>New Jersey</AuthorLocation>
            </AuthorDetails>
          </AuthorInfo>
        </TestimonialCard>
      </Container>
    </TestimonialsSection>
  );
};

export default Testimonials;
